import e from "./Tooltip_vue.js";
//#region src/components/ui/tooltip/core/Tooltip.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=Tooltip.js.map